'use client';

import { Wizard } from '@/components/wizard/Wizard';

import { CreateSparkEngineFlow } from './CreateSparkEngineFlow';
import {
  defaultCreateSparkEngineWizardState,
  type CreateSparkEngineWizardState,
} from './createSparkEngineWizardState';

interface CreateSparkEngineWizardPanelProps {
  workspaceId: string;
  workspaceCloud: string;
  onAbort: () => void;
  onCreated: () => void;
}

export function CreateSparkEngineWizardPanel({
  workspaceId,
  workspaceCloud,
  onAbort,
  onCreated,
}: CreateSparkEngineWizardPanelProps) {
  return (
    <Wizard<CreateSparkEngineWizardState>
      onAbort={onAbort}
      hideBackArrow={true}
      onFinish={async () => {
        onCreated();
        return true;
      }}
      flow={[CreateSparkEngineFlow]}
      initialState={{
        ...defaultCreateSparkEngineWizardState,
        workspaceId,
        workspaceCloud,
      }}
      title='Create Spark Engine'
      stepperLabels={[]}
    />
  );
}
